var Aneox;
(function (Aneox) {
  'use strict';

  var Scroll = (function () {

    var scrollRetainCount = 0;
    var lastScrollAction;
    var manualScroll = false;

    function Scroll(animations, locale, router) {
      this.animations = animations;
      this.locale = locale;
      this.router = router;
      var self = this;

      // Wheel handling
      var position = 0;
      var scrollEndTimeout;
      
      $(window).on('mousewheel', function (event) {
        clearTimeout(scrollEndTimeout);

        if (!self.animations.sequences || !self.animations.sequences.main) return;

        if (scrollRetainCount !== 0) return;
        
        if (_.includes(['pageChange','windowResize','scrollToKeyframe'], lastScrollAction))
          position = self.animations.sequences.main.getTime() / self.animations.sequences.main.duration * self.animations.sequences.main.scrollHeight;
  
        position -= event.deltaY * event.deltaFactor * 1.5;
        position = Math.max(0, Math.min(self.animations.sequences.main.scrollHeight, position));

        var scrollPercent = position / self.animations.sequences.main.scrollHeight;
        var time = scrollPercent * self.animations.sequences.main.duration;

        self.animations.sequences.main.setTime(time, 0.25, Power0.easeNone);
        checkKeyframes.call(self, time);
        
        lastScrollAction = 'mouseWheel';

        scrollEndTimeout = setTimeout(function() {
          position -= event.deltaY * event.deltaFactor * 1.5;
          position = Math.max(0, Math.min(self.animations.sequences.main.scrollHeight, position));

          scrollPercent = position / self.animations.sequences.main.scrollHeight;
          time = scrollPercent * self.animations.sequences.main.duration;

          self.animations.sequences.main.setTime(time, 1, Power2.easeOut);
          checkKeyframes.call(self, time);
        }, 100);
      });
      
      // Touch handling
      var lastPanDirectionY;
      var lastPanDeltaY;
      var lastPanVelocityY;
      var targetPanId;
      
      if (this.animations.isTouchDevice) {
        var mc = new Hammer.Manager(document.body);
        mc.add(new Hammer.Pan({ threshold: 0, pointers: 0, direction: Hammer.DIRECTION_VERTICAL }));
        mc.on('panstart panmove panend', function (event) {
          if (scrollRetainCount !== 0) return;
          
          if (event.type === 'panstart') targetPanId = event.srcEvent.target.getAttribute('id');
          if (targetPanId === 'scrollbar' || targetPanId === 'scroller') return;
          
          if (event.type === 'panstart') lastPanDeltaY = 0;
          
          if (_.includes(['pageChange','windowResize','scrollToKeyframe'], lastScrollAction))
            position = self.animations.sequences.main.timeline.time() / self.animations.sequences.main.duration * self.animations.sequences.main.scrollHeight;
          
          var absoluteVelocityY = Math.abs(lastPanVelocityY);
          var scrollDuration;
          
          if (event.type === 'panend' && absoluteVelocityY > 0.5) {
            position -= absoluteVelocityY * lastPanDirectionY * 200;
            scrollDuration = absoluteVelocityY / 3;
          } else {
            position -= event.deltaY - lastPanDeltaY;
          }
          
          position = Math.max(0, Math.min(self.animations.sequences.main.scrollHeight, position));
  
          lastPanDirectionY = (event.deltaY - lastPanDeltaY) >= 0 ? 1 : -1;
          lastPanDeltaY = event.deltaY;
          lastPanVelocityY = event.velocityY;
  
          var scrollPercent = position / self.animations.sequences.main.scrollHeight;
          var time =  scrollPercent * self.animations.sequences.main.duration;
        
          self.animations.sequences.main.setTime(time, scrollDuration);
          checkKeyframes.call(self, time);
          
          lastScrollAction = 'pan';
        });
      }

    }

    var scrollPosition = null;

    Scroll.prototype.resetScrollPosition = function() {
      scrollPosition = null;
    };

    Scroll.prototype.incrementScrollRetainCount = function(savePosition) {
      if (typeof savePosition === 'undefined') savePosition = true;

      if (savePosition) {
        if (scrollRetainCount === 0 && this.animations.sequences && this.animations.sequences.main) {
          scrollPosition = this.animations.sequences.main.getTime();
        }
      } else {
        this.resetScrollPosition();
      }
      scrollRetainCount++;
      return this;
    };
    
    Scroll.prototype.decrementScrollRetainCount = function(pageType) {
      if (scrollPosition !== null && scrollRetainCount === 1 &&
          this.animations.sequences && this.animations.sequences.main) {
        this.animations.sequences.main.setTime(scrollPosition);
      }
      scrollRetainCount = Math.max(scrollRetainCount - 1, 0);
      return this;
    };

    Scroll.prototype.resetScrollRetainCount = function() {
      scrollRetainCount = 0;
      return this;
    };

    Scroll.prototype.lastScrollAction = function(value) {
      if (value) lastScrollAction = value;
      else return value;
    };

    Scroll.prototype.isManual = function() {
      return manualScroll;
    };

    Scroll.prototype.cancelManualScroll = function() {
      manualScroll = false;
      return this;
    };

    Scroll.prototype.setManualScroll = function() {
      manualScroll = true;
      return this;
    };

    var checkKeyframes = _.debounce(function (time) {
      var keyframe;
      var keyframeTime = 0;
      
      _.forOwn(this.animations.sequences.main.keyframes, function (value, key) {
        if (time >= value && value >= keyframeTime) {
          keyframe = key;
          keyframeTime = value;
        }
      });
      
      if (!keyframe) return;

      manualScroll = true;
      setPage.call(this, keyframe);

    }, 250);

    var setPage = function (nodeId, isNotKeyframe) {
      if (nodeId === this.router.getNode().id) return;
      
      var path = this.router.getNodePath(nodeId, this.locale.getLocale());
      if (path === undefined) return;
      
      this.router.setPath(path);
    };

    return Scroll;
  })();

  Aneox.Scroll = Scroll;
})(Aneox || (Aneox = {}));